<template>
  <div class="wrap">
    <slot name="mainTitle"/>
    <com-title :subtitle="title"></com-title>
    <div class="container">
      <ul class="columns" :class="{'is-center': itemIsCenter}">
        <li v-for="(item, index) in partners" :key="index" class="column is-one-third-tablet">
          <a class="wrap" :href="item.link" target="_blank">
            <div class="content-wrapper">
              <div class="logo">
                <img :src="item.avatar" alt="">
              </div>
              <div class="word">
                <span class="word-content">{{item.word}}</span>
                <!-- <div class="word-author">
                  <span>{{item.author}}</span>
                  <span>{{item.company}}</span>
                </div> -->
              </div>
            </div>
            <!-- <div class="hover">
              <span class="word-content">{{item.word}}</span> -->
              <!-- <div class="word-author">
                <span>{{item.author}}</span>
                <span>{{item.company}}</span>
              </div> -->
            <!-- </div> -->
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import comTitle from '@/base/ego-title'
export default {
  data () {
    return {}
  },
  components: {
    comTitle
  },
  props: ['partners', 'title', 'itemIsCenter']
}
</script>
<style scoped lang='sass'>
@import "../../../style/bulma/app.sass"

.wrap
  .container
    // margin-top: 60px
    padding: 30px 0 50px
    +mobile
      width: 88vw
      padding: 20px 0 30px
      // margin-top: 40px
    ul
      flex-wrap: wrap
      align-items: stretch
      &.is-center
        justify-content: center
      li
        a
          display: block
          padding: 0.75rem
          padding-top: 0
          height: 100%
          background-color: #fff
          box-shadow: 0px 4px 15px 0px rgba(7, 17, 27, 0.1)
          border-radius: 5px
          position: relative
          transition: all 0.2s ease
          &:hover
            transform: translateY(-10px)
            +mobile
              transform: translateY(0px)
            // .hover
            //   opacity: 1
            //   background-color: #2663a0
            //   color: #fff
          .hover
            position: absolute
            left: 0
            top: 0
            width: 100%
            height: 100%
            opacity: 0
            padding: 1.95rem
            font-size: 14px
            background-color: #fff
            transition: all 0.3s linear
            display: flex
            align-items: center
            justify-content: center
          +mobile
            height: auto
          .content-wrapper
            padding: 1.2rem
            padding-top: 0
            .logo
              border-bottom: 1px solid #ddd
              display: flex
              align-items: center
              justify-content: center
              height: 80px
              img
                height: 68%
            .word
              margin-top: 20px
              display: flex
              flex-direction: column
              align-items: flex-end
              .word-author
                font-size: 14px
                color: #888
                display: flex
                flex-direction: column
                align-items: flex-end
              .word-content
                font-size: 14px
                // margin-bottom: 20px
                color: #353535
                // +limit-line-numbers(9)
        &:nth-child(1)
          .logo
            img
              height: 100% !important
</style>
